// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5597":"7636f9dc","5650":"254189ec","8777":"fe58350d"}[chunkId] + ".chunk.css";
};